import { Box, Grid, Skeleton } from '@mui/material';
import { SocialAuthSkeleton } from '../social-auth/SocialAuthSkeleton';

export const SignupFormSkeleton: React.FC = () => {
  return (
    <Box sx={{ py: 7.5 }}>
      <Skeleton variant="text" height="5rem" width="75%" />
      <Skeleton variant="text" height="1.5rem" width="20%" sx={{ mt: 1, mb: 4 }} />
      <SocialAuthSkeleton />
      <Box sx={{ mt: 3.75 }}>
        <Grid sx={{ mt: 2 }} container spacing={2.5}>
          {Array(3)
            .fill('')
            .map((_item, index) => (
              <Grid item xs key={index}>
                <Skeleton variant="text" sx={{ mb: 0.5 }} width="10rem" />
                <Skeleton variant="rectangular" height="2.5rem" />
              </Grid>
            ))}
        </Grid>
        <Box sx={{ py: 2.5 }}>
          <Skeleton variant="text" sx={{ mb: 0.5 }} width="10rem" />
          <Skeleton variant="rectangular" height="2.5rem" />
        </Box>
        <Grid container spacing={2.5}>
          {Array(2)
            .fill('')
            .map((_item, index) => (
              <Grid item xs key={index}>
                <Skeleton variant="text" sx={{ mb: 0.5 }} width="10rem" />
                <Skeleton variant="rectangular" height="2.5rem" />
              </Grid>
            ))}
        </Grid>
        <Skeleton sx={{ mt: 2.5 }} variant="rectangular" height="2.5rem" width="7.5rem" />
      </Box>
    </Box>
  );
};
